export default __webpack_public_path__ + "static/media/mixtMap.ed6a3210.jpg";